import {
    Flex,
    Stack,
    Heading,
    Text,
    Button,
    Wrap,
    WrapItem,
    useColorModeValue,
    useDisclosure,
    useMediaQuery,
} from '@chakra-ui/react'

import config from '../../../../Config/config'

import CustomHighlight from '../../../../Components/Elements/CustomHighlight'

import { IoOptions } from "react-icons/io5";
import { FaRegCheckCircle } from "react-icons/fa";

import HeroSearchInput from './HeroSearchInput';
import HeroDesktopFilter from './HeroDesktopFilter';
import HeroMobileFilter from './HeroMobileFilter';
import SortBy from './Filter/SortBy';

const BrowseHero = () => {
    const buttonBgColor = useColorModeValue('gray.200', 'gray.700')

    const isDesktop = useMediaQuery("(min-width: 768px)")
    const { isOpen, onOpen, onClose } = useDisclosure()

    return (
        <>
            <Flex
                w={'full'}
                h={'60vh'}
                backgroundImage={`linear-gradient(rgba(0, 0, 0, 0.4),rgba(0, 0, 0, 0.4)), url('${config.SCHOLARSHIPS_HERO_BACKGROUND_IMAGE}')`}
                backgroundSize={'cover'}
                backgroundPosition={'center center'}
                backgroundAttachment={'fixed'}
            >
                <Stack
                    direction={'column'}
                    w={'full'}
                    textAlign={'center'}
                    align={'center'}
                    justify={'center'}
                >
                    <Stack direction={'column'} maxW={'4xl'} p={5} spacing={5}>
                        <Stack direction={'column'}>
                            <Heading
                                fontWeight={700}
                                fontSize={'4xl'}
                            >
                                <CustomHighlight query={['Find & Apply To Scholarships Easily']} color={'white'}>
                                    Find & Apply To Scholarships Easily
                                </CustomHighlight>
                            </Heading>
                            <Wrap justify={'center'}>
                                <WrapItem>
                                    <Stack direction={'row'} align={'center'}>
                                        <FaRegCheckCircle color={'green'} size={24} />
                                        <Text fontSize={'2xl'} color={'white'}>100+ scholarships</Text>
                                    </Stack>
                                </WrapItem>
                                <WrapItem>
                                    <Stack direction={'row'} align={'center'}>
                                        <FaRegCheckCircle color={'green'} size={24} />
                                        <Text fontSize={'2xl'} color={'white'}>up-to-date</Text>
                                    </Stack>
                                </WrapItem>
                                <WrapItem>
                                    <Stack direction={'row'} align={'center'}>
                                        <FaRegCheckCircle color={'green'} size={24} />
                                        <Text fontSize={'2xl'} color={'white'}>free</Text>
                                    </Stack>
                                </WrapItem>
                            </Wrap>
                        </Stack>
                        <Stack direction={'column'}>
                            <HeroSearchInput />
                            {!isDesktop[0] &&
                                // Mobile Filters and Sort by buttons
                                <Stack direction={'row'} w={'full'} justify={'space-between'}>
                                    <Button
                                        _focus={{}}
                                        _active={{}}
                                        _hover={{}}
                                        bgColor={buttonBgColor}
                                        variant={'outline'}
                                        borderRadius={'full'}
                                        leftIcon={<IoOptions />}
                                        onClick={() => onOpen()}
                                        fontSize={'lg'}
                                    >Filters</Button>
                                    <SortBy />
                                </Stack>
                            }
                            {isDesktop[0] && <HeroDesktopFilter />}
                        </Stack>
                    </Stack>
                </Stack>
            </Flex>
            <HeroMobileFilter onClose={onClose} isOpen={isOpen} />
        </>
    )
}

export default BrowseHero